import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { IWorksheetComponent } from 'Components/Worksheets/Core';
import React from 'react';
import { useSelector } from 'react-redux';
import { Field, NumericInput, TextOutput } from '../../../../Core';
import { ListFieldSection } from '../../../../Layout';
import { MoistureContentMethodList } from '../../types';

let AsLinearShrinkageTestForMCSectionMeasured: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const Method = useSelector(createWorksheetSelector!('Preparation.MoistureConditionTestMethod'));
  return (
    <>
      <ListFieldSection heading="Test For Moisture Condition">
        <Field input={<TextOutput />} name="Preparation.MoistureConditionTestMethod" />
        <Field input={<TextOutput />} name="Preparation.NumberOfBlows" />
        <Field
          input={<NumericInput />}
          name="Preparation.ConePenetration"
          visible={Method === MoistureContentMethodList[2] || Method === MoistureContentMethodList[3]}
        />
      </ListFieldSection>
    </>
  );
};

AsLinearShrinkageTestForMCSectionMeasured = withInjectedProps(AsLinearShrinkageTestForMCSectionMeasured);

export { AsLinearShrinkageTestForMCSectionMeasured };
export default AsLinearShrinkageTestForMCSectionMeasured;
